enum LoanPayoutFigureSectionTypeEnum {
    DefaultFees = 'DEFAULT_FEES',
    Interest = 'INTEREST',
    Other = 'OTHER',
    Renewal = 'RENEWAL',
}

export default LoanPayoutFigureSectionTypeEnum;
